import { useForm } from "react-hook-form";
import { TWaterMeter, TWaterSubscriber } from "types/dto";
import { useEffect, useState } from "react";

export type TInstallForm = {
  subscriber: TWaterSubscriber;
  waterMeter: TWaterMeter;
  description: string;
  installationDate: string;
  location: { lat: number; lng: number } | null;
  images: File[];
  signature: string;
};

export const useInstallForm = () => {
  const methods = useForm<TInstallForm>({
    defaultValues: {
      subscriber: undefined,
      waterMeter: undefined,
      description: "",
      installationDate: "",
      location: null,
      images: [],
      signature: "",
    },
  });

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    console.log("Form values changed:", methods.getValues());
  }, [methods.watch()]);
  const loadFromStorage = () => {
    const data = localStorage.getItem("install-form");
    if (data) {
      setHasUnsavedChanges(true);
      methods.reset(JSON.parse(data));
    }
  };

  const saveToStorage = () => {
    localStorage.setItem("install-form", JSON.stringify(methods.getValues()));
  };

  const loadFromApi = async (id: string) => {
    // simulate API
    const res = await fetch(`/api/install/${id}`);
    const data = await res.json();
    methods.reset(data);
  };

  return {
    methods,
    hasUnsavedChanges,
    loadFromStorage,
    saveToStorage,
    loadFromApi,
  };
};
